(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sureway-detail-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sureway-detail-carousel')) {
    customElements.define('sureway-detail-carousel', class extends HTMLElement {
      connectedCallback() {
        cancelAnimationFrame(this.initFrame);
        this.initFrame = requestAnimationFrame(() => this.initialize());
      }

      initialize() {
        if (!this.isConnected) return;
        if (this.abortController) return;
        this.viewport = this.querySelector('[data-sw-viewport]');
        this.slides = Array.from(this.querySelectorAll('[data-sw-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-sw-dot]'));
        if (!this.viewport || !this.slides.length) return;
        this.index = 0;
        this.abortController = new AbortController();
        const options = { signal: this.abortController.signal };
        this.querySelector('[data-sw-prev]').addEventListener('click', () => this.go(this.index - 1), options);
        this.querySelector('[data-sw-next]').addEventListener('click', () => this.go(this.index + 1), options);
        this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.go(index), options));
        this.viewport.addEventListener('keydown', event => {
          const targets = { ArrowLeft: this.index - 1, ArrowRight: this.index + 1, Home: 0, End: this.maxIndex };
          if (event.key in targets) {
            event.preventDefault();
            this.go(targets[event.key]);
          }
        }, options);
        this.viewport.addEventListener('scroll', () => {
          cancelAnimationFrame(this.scrollFrame);
          this.scrollFrame = requestAnimationFrame(() => {
            if (!this.stride) return;
            const index = Math.max(0, Math.min(this.maxIndex, Math.round(this.viewport.scrollLeft / this.stride)));
            if (index !== this.index) this.update(index);
          });
        }, { ...options, passive: true });
        this.querySelectorAll('img').forEach(img => img.addEventListener('load', () => this.fitHeight(), options));
        this.resizeObserver = new ResizeObserver(() => {
          this.layout();
          this.fitHeight();
        });
        this.resizeObserver.observe(this.viewport);
        this.slides.forEach(slide => this.resizeObserver.observe(slide));
        this.layout();
      }

      layout() {
        const columns = Number(getComputedStyle(this.viewport).getPropertyValue('--sw-columns')) || 1;
        this.visibleCount = Math.min(columns, this.slides.length);
        this.maxIndex = this.slides.length - this.visibleCount;
        this.stride = this.slides.length > 1
          ? this.slides[1].offsetLeft - this.slides[0].offsetLeft
          : this.viewport.clientWidth;
        const index = Math.min(this.index, this.maxIndex);
        const layoutKey = `${this.viewport.clientWidth}:${this.stride}:${this.visibleCount}`;
        if (layoutKey !== this.layoutKey) {
          this.layoutKey = layoutKey;
          this.viewport.scrollTo({ left: index * this.stride, behavior: 'instant' });
        }
        this.querySelectorAll('[data-sw-controls]').forEach(control => {
          control.hidden = this.maxIndex < 1;
        });
        this.dots.forEach((dot, dotIndex) => { dot.hidden = dotIndex > this.maxIndex; });
        this.update(index, false);
      }

      go(index) {
        const next = (index + this.maxIndex + 1) % (this.maxIndex + 1);
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.viewport.scrollTo({ left: next * this.stride, behavior: reduceMotion ? 'instant' : 'smooth' });
      }

      update(index, announce = true) {
        this.index = index;
        this.dots.forEach((dot, dotIndex) => {
          if (dotIndex === index) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
        this.slides.forEach((slide, slideIndex) => {
          slide.setAttribute('aria-hidden', slideIndex >= index && slideIndex < index + this.visibleCount ? 'false' : 'true');
        });
        this.fitHeight();
        if (announce) this.querySelector('[data-sw-status]').textContent = this.visibleCount > 1 ? `Images ${index + 1} to ${index + this.visibleCount} of ${this.slides.length}` : `Image ${index + 1} of ${this.slides.length}`;
      }

      fitHeight() {
        const slide = this.slides[this.index];
        const height = slide ? slide.getBoundingClientRect().height : 0;
        if (height > 0) {
          const value = `${height}px`;
          if (this.viewport.style.height !== value) this.viewport.style.height = value;
          this.setAttribute('data-sw-ready', '');
        }
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.initFrame);
        if (this.abortController) this.abortController.abort();
        if (this.resizeObserver) this.resizeObserver.disconnect();
        cancelAnimationFrame(this.scrollFrame);
        this.abortController = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sureway-faq-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sureway-faq-tabs')) {
    customElements.define('sureway-faq-tabs', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.tabs = Array.from(this.querySelectorAll('.swfaq__tab'));
        this.panels = Array.from(this.querySelectorAll('.swfaq__panel'));
        const tablist = this.querySelector('.swfaq__tabs');
        if (!tablist || !this.tabs.length) return;
        this.panels.forEach(panel => {
          panel.setAttribute('role', 'tabpanel');
          panel.setAttribute('aria-labelledby', this.tabs.find(tab => tab.dataset.category === panel.dataset.category).id);
          panel.tabIndex = 0;
        });
        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.activate(tab.dataset.category), options);
          tab.addEventListener('keydown', event => {
            let next = index;
            if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
            else if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
            else if (event.key === 'Home') next = 0;
            else if (event.key === 'End') next = this.tabs.length - 1;
            else return;
            event.preventDefault();
            this.activate(this.tabs[next].dataset.category);
            this.tabs[next].focus();
          }, options);
        });
        document.addEventListener('shopify:block:select', event => {
          const row = Array.from(this.querySelectorAll('[data-block-id]')).find(item => item.dataset.blockId === event.detail?.blockId);
          if (!row) return;
          this.activate(row.closest('.swfaq__panel').dataset.category);
          row.open = true;
        }, options);
        this.classList.add('swfaq--ready');
        tablist.hidden = false;
        this.activate(this.tabs[0].dataset.category);
      }
      disconnectedCallback() { this.controller?.abort(); }
      activate(category) {
        this.tabs.forEach(tab => {
          const active = tab.dataset.category === category;
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
        });
        this.panels.forEach(panel => { panel.hidden = panel.dataset.category !== category; });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
